import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export interface ModeControlSimpleData {
  label: string;
  icon: string;
  color?: string;
  backgroundColor?: string;
  backgroundImage?: string;
}

@Component({
  selector: 'app-mode-control-simple',
  templateUrl: './mode-control-simple.component.html',
  styleUrls: ['./mode-control-simple.component.scss'],
  imports: [TranslatePipe],
})
export class ModeControlSimpleComponent {
  @Input() data: ModeControlSimpleData | null = null;
  @Input() value: number = 0;

  //eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onPress = new EventEmitter<number>();
  //eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onTouchStart = new EventEmitter<number>();
  //eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onTouchEnd = new EventEmitter<number>();

  onButtonClick(): void {
    this.onPress.emit();
  }

  onButtonTouchStart(): void {
    this.onTouchStart.emit();
  }

  onButtonTouchEnd(): void {
    this.onTouchEnd.emit();
  }
}
